import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import client from '../api/client';
import './Login.css';

export default function Register() {
  const [form, setForm] = useState({ name: '', email: '', password: '', organisationName: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const set = (k: string) => (e: React.ChangeEvent<HTMLInputElement>) =>
    setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await client.post('/api/armundi/auth/register', {
        email: form.email,
        password: form.password,
        firstName: form.name,
        orgName: form.organisationName,   // ← war: organisationName
      });
      navigate('/login');
    } catch (err: any) {
      setError(err.response?.data?.error || 'Registrierung fehlgeschlagen.');
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <img src="/logo-pos.png" alt="ARmundi" />
        </div>
        <h1 className="auth-title">Registrieren</h1>
        <p className="auth-subtitle">Erstellen Sie ein neues Konto.</p>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label>Name</label>
            <input value={form.name} onChange={set('name')} placeholder="Max Mustermann" required autoFocus />
          </div>
          <div className="form-group">
            <label>Organisation</label>
            <input value={form.organisationName} onChange={set('organisationName')} placeholder="Firma GmbH" required />
          </div>
          <div className="form-group">
            <label>E-Mail</label>
            <input type="email" value={form.email} onChange={set('email')} placeholder="name@firma.de" required />
          </div>
          <div className="form-group">
            <label>Passwort</label>
            <input type="password" value={form.password} onChange={set('password')} placeholder="Min. 8 Zeichen" required minLength={8} />
          </div>
          <button type="submit" className="btn-primary btn-full" disabled={loading}>
            {loading ? 'Wird registriert...' : 'Konto erstellen'}
          </button>
        </form>

        <p className="auth-switch">
          Bereits registriert? <Link to="/login">Anmelden</Link>
        </p>
      </div>
    </div>
  );
}
